import { DropdownMenuItem } from '@radix-ui/react-dropdown-menu';
import clsx from 'clsx';
import { ReactNode } from 'react';

type DropdownItemProps = {
  children: ReactNode;
  className?: string;
  handleClick?: React.MouseEventHandler<HTMLDivElement>;
  handleKeyDown?: React.KeyboardEventHandler<HTMLDivElement>;
  disabled?: boolean;
};

export const DropdownItem = (props: DropdownItemProps) => (
  <DropdownMenuItem
    onClick={props.disabled ? undefined : props?.handleClick}
    onKeyDown={props.disabled ? undefined : props?.handleKeyDown}
    className={clsx(
      `border-b border-neutral-800 bg-neutral-white px-4 py-2 last:border-b-0 focus:outline-none`,
      {
        'cursor-pointer hover:bg-neutral-950': !props.disabled,
        'pointer-events-none text-neutral-500 opacity-50': props.disabled,
      },
      props.className,
    )}
  >
    {props.children}
  </DropdownMenuItem>
);
